<ul class="autocomplete__results" *ngIf="((!results || !results.length) && showResults) || INDRA_showResults() || (showResults && loading)" role="listbox">
	<!-- Options -->
	<ng-container *ngIf="(!results || !results.length) && showResults && !loading">
		<li class="autocomplete__options__item" *ngFor="let option of autocompleteOptions; let i = index" (click)=INDRA_handleOptionClick(option.id) [attr.aria-label]="option.aria">
			<app-svg aria-hidden="true" svg="{{option.icon}}" [alt]="option.label + ' icon'"></app-svg>
			<span aria-hidden="true">
				{{ option.label | ibeadmin | async }}
				<span class="autocomplete__item-description" *ngIf=option.description>
					{{ option.description | ibeadmin | async }}</span>
			</span>
		</li>

		<ng-container *ngIf="showLastSearch && lastSearchOptions.length">
			<li class="autocomplete__options__item autocomplete__options__item--last-search" 
				*ngFor="let option of lastSearchOptions; let i = index" 
				(click)=INDRA_handleLastSearchClick(option) 
				aria-label="Recent Searches">
				<span aria-hidden="true">
					<span class="autocomplete__item-description">{{ 'Search.text.recentSearches' | ibeadmin | async }}</span>

					{{option.value.departure.code}} — {{option.value.departure.location.city}}
					<app-svg class="selected-arrow" svg="icons.svg#general--arrow--long_right" [alt]="'Arrow right icon'"></app-svg>
					{{option.value.arrival.code}} — {{option.value.arrival.location.city}}

				</span>
			</li>
		</ng-container>
	</ng-container>

	<!-- Airport results -->
	<ng-container *ngIf="INDRA_showResults()">
		<li class="autocomplete__results__item" 
			*ngFor="let result of results; let i = index" 
			(click)="INDRA_handleSelect(result)" 
			[ngClass]="INDRA_isFocusedResult(i)" 
			[attr.aria-label]="INDRA_printSelectResultAria(result)">
			
			<span aria-hidden="true" class="autocomplete__results__item-iata">
				{{INDRA_printAirportCode(result)}}
			</span>
			
			<span aria-hidden="true">
				<span class="bold">{{INDRA_printAirportName(result)}}</span>
				{{INDRA_printAirportCountry(result)}}
			</span>
		</li>
	</ng-container>

	<!-- Airport results loading -->
	<ng-container *ngIf="shouldOpen && loading">
		<li class="autocomplete__results__item autocomplete__results__loading" *ngFor="let result of [0,1,2,3,4]">
			<app-loading-shadow class="autocomplete__results__loading-code"></app-loading-shadow>
			<app-loading-shadow class="autocomplete__results__loading-name"></app-loading-shadow>
		</li>
	</ng-container>
</ul>

<span tabindex="-1" role="alert" aria-atomic="true" class="visuallyhidden helper-accessible">{{resultsAriaAlert}}</span>
